import { fetchToken } from "../../common/FetchCookie"

const BASE_URL = "https://api.indiahirings.com/employer"

export const addCompanyInterview = async (newData) => {
  const url = `${BASE_URL}/company-interview-process`
  try {
    const token = await fetchToken()
    if (!token) throw new Error("Authentication token is missing!")
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newData),
    })
    return await response.json()
  } catch (error) {
    console.error("Add error:", error)
    throw error
  }
}

export const updateCompanyInterview = async (uuid, updatedData) => {
  const url = `${BASE_URL}/company-interview-process/${uuid}`
  try {
    const token = await fetchToken()
    if (!token) throw new Error("Authentication token is missing!")
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedData),
    })
    return await response.json()
  } catch (error) {
    console.error("Update error:", error)
    throw error
  }
}

export const deleteCompanyInterview = async (uuid) => {
  const url = `${BASE_URL}/company-interview-process/${uuid}`
  try {
    const token = await fetchToken()
    if (!token) throw new Error("Authentication token is missing!")
    const response = await fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    return await response.json()
  } catch (error) {
    console.error("Delete error:", error)
    throw error
  }
}